import { useProductsStore } from "../../../utils/stores/useProductsStore"
import { useIsMetabolicUser } from "../../metabolic-health/hooks/useMetabolicHealth"

export const useChat = () => {
    const isMetabolicUser = useIsMetabolicUser()
    const { productsData } = useProductsStore()
    const membership = productsData.membership

    const isChatAvailable = !!(isMetabolicUser || (membership && membership.status === "active"))

    return { isChatAvailable }
}